module.exports = __webpack_public_path__ + "static/media/飞机跑道融雪除冰.b9074049.jpg";